import {
  CHANGE_SEND_BUDGET,
  SENDING_MESSAGE,
  SEND_COMPLETE,
  RESET_SEND,
  SET_FOOTER_VALUES,
  DEL_CAPITULO_SET_POSITION,
  SET_MODAL_BUDGETING_ERROR,
  REMOVE_ALL_PARTS_FROM_CHAPTER,
  IS_CONTRADICTING_PART,
  SET_LOADING_ICON,
  IS_BUDGET_CLOSED,
  SET_CLOSE_INFO,
  MOVE_PARTS_BY_CHAPTERS_ID,
  SET_DYNAMIC_ELEMENT_SELECTED,
  SET_DYNAMIC_ELEMENT_MODAL_IS_OPEN,
  SET_DYNAMIC_ELEMENT_PROJECT_ID,
  SET_GENERAL_UPDATE,
  CERTIFICATION_LOADING,
  SET_CHAPTER_CERT_IN_PROGRESS,
  CERT_DRAFT_SET_PARTIDA,
  SET_MARGIN_MODAL,
  SET_MARGIN_MODAL_INITIAL_VALUE,
} from "../types"

const Budget2023Reducer = (state, action) => {
  switch (action.type) {
    case SET_FOOTER_VALUES:
      state.budgetTree.calculateFooterValues()
      return {
        ...state,
        loading: false,
      }
    case "SET_BUDGET_TREE":
      state.budgetTree.subcapitulos = action.payload
      return {
        ...state,
        loading: false,
        certDraftPartidaIds: {},
      }
    case "SET_COEFFICIENTS": {
      return {
        ...state,
        coefficients: action.payload,
      }
    }
    case SET_CLOSE_INFO: {
      return {
        ...state,
        closeInfo: action.payload,
      }
    }
    case "DEL_CAPITULO":
      state.budgetTree.remove(action.payload.capituloId)
      if (
        action.payload.totalDiscount != undefined ||
        action.payload.totalDiscount != null
      ) {
        state.budgetTree.updateDiscount(action.payload.totalDiscount, "root")
      }
      return {
        ...state,
        updating: false,
      }
    case "DEL_PARTIDA":
      state.budgetTree.removePartida(
        action.payload.capituloId,
        action.payload.partidaId,
      )
      if (
        action.payload.totalDiscount != undefined ||
        action.payload.totalDiscount != null
      ) {
        state.budgetTree.updateDiscount(action.payload.totalDiscount, "root")
      }
      return {
        ...state,
        updating: false,
      }
    case "DEL_PARTIDA_MOVE":
      state.budgetTree.removePartidaMove(
        action.payload.capituloId,
        action.payload.partidaId,
      )
      if (
        action.payload.totalDiscount != undefined ||
        action.payload.totalDiscount != null
      ) {
        state.budgetTree.updateDiscount(action.payload.totalDiscount, "root")
      }
      return {
        ...state,
        updating: false,
      }
    case "CLEAN_PARTS":
      return {
        ...state,
        partsChecked: [],
      }
    case "UNCHECK_ALL":
      state.budgetTree.checkCapitulo("root", false)
      return {
        ...state,
        chaptersChecked: [],
        partsChecked: [],
      }
    case "ADD_PARTIDA":
      state.budgetTree.addPartida(
        action.payload.chapterId,
        action.payload.partidaNueva,
        action.payload.tmpIndex - 1,
      )
      return {
        ...state,
        updating: false,
      }
    case "ADD_PARTIDA_MOVE":
      state.budgetTree.addPartida(
        action.payload.chapterId,
        action.payload.partidaNueva,
        action.payload.tmpIndex,
      )
      return {
        ...state,
        updating: false,
      }
    case "REORDER_PARTIDA_WITHIN_CHAPTER":
      state.budgetTree.reorderPartidaWithinChapter(
        action.payload.chapterId,
        action.payload.partidaId,
        action.payload.targetIndex,
      )
      return {
        ...state,
        updating: false,
      }

    case "ADD_CAPITULO":
      state.budgetTree.addCapitulo(
        action.payload.parentId,
        action.payload.res,
        action.payload.indexCapitulo,
      )
      return {
        ...state,
        updating: false,
      }
    case "FILL_CHAPTER_CONTENT":
      state.budgetTree.fillChapterContent(
        action.payload.chapterId,
        action.payload.content,
      )
      return {
        ...state,
        updating: false,
      }
    case "FILL_CHAPTER_CONTENT_2":
      state.budgetTree.fillChapterContent2(
        action.payload.chapterId,
        action.payload.content,
      )
      return {
        ...state,
        updating: false,
      }
    case "LOADING_BUDGET":
      return {
        ...state,
        loading: action.payload.loading,
        budgetTree: action.payload.budgetTree,
      }
    case "ERR_BUDGET_TREE":
      return {
        ...state,
        loading: action.payload.loading,
      }
    case "UPDATE_IS_EXPANDED":
      state.budgetTree.updateIsExpanded(action.payload)
      return {
        ...state,
      }
    case "CHECK_CAPITULOS":
      state.budgetTree.checkCapitulo(
        action.payload.capituloId,
        action.payload.value,
      )
      return {
        ...state,
      }
    case "CHECK_PARTIDA":
      state.budgetTree.checkPartida(
        action.payload.capituloId,
        action.payload.partidaId,
      )
      return {
        ...state,
      }
    case "UPDATE_PARTIDA":
      state.budgetTree.updatePartida(
        action.payload.newData,
        action.payload.capituloId,
        action.payload.final,
      )
      return {
        ...state,
        updating: false,
      }
    case "PATCH_PARTIDA_BY_ID":
      state.budgetTree.patchPartidaById(
        action.payload.partidaId,
        action.payload.changes,
      )
      return {
        ...state,
        updating: false,
      }
    case "ADD_IMAGE":
      state.budgetTree.updatePartida(
        action.payload.newData,
        action.payload.capituloId,
        action.payload.final,
      )
      return {
        ...state,
        updating: false,
      }
    case "UPDATE_CAPITULO":
      state.budgetTree.updateCapitulo(
        action.payload.newData,
        action.payload.capituloId,
      )
      return {
        ...state,
        updating: false,
      }
    case "SET_SELECTED":
      return {
        ...state,
        selectedBudget2: action.payload.selectedBudget,
      }
    case "ON_UPDATE":
      return {
        ...state,
        updating: true,
      }
    case "ON_UPDATE_RECALC":
      return {
        ...state,
        loadingRecalc: true,
      }
    case "RECALC_DONE":
      return {
        ...state,
        loadingRecalc: false,
      }
    case "CLOSE_BUDGET":
      state.budgetTree.checkEmpty()
      return {
        ...state,
        readyToClose: !state.budgetTree.warning,
      }
    case "CHECK_UPDATES":
      state.budgetTree.checkUpdates()
      return {
        ...state,
      }

    case "DOWNLOADING_BUDGET":
      return {
        ...state,
        urlDownload: "pending",
      }
    case "DOWNLOAD_BUDGET":
      return {
        ...state,
        urlDownload: "done",
      }
    case "SET_GROUP":
      return {
        ...state,
        selectedPartGroup: action.payload.selectedParts,
        errorAgrupar: false,
      }
    case "SELECCIONAR_AGRUPAR":
      return {
        ...state,
        selectedChaptersGroup: action.payload.selectedBudget,
      }
    case "ERROR_CAPITULO":
      return {
        ...state,
        selectedPartGroup: [],
        errorAgrupar: true,
      }
    case "CHANGE_DIMENSIONS":
      return {
        ...state,
        changeSidebar: action.payload.num + 1,
      }
    case "UPDATE_PARTS_LIST":
      return {
        ...state,
        partsChecked: action.payload.list,
      }
    case "UPDATE_CHAPTERS_LIST":
      return {
        ...state,
        chaptersChecked: action.payload.list,
      }
    case "CHANGE_MOVING":
      return { ...state, imChecked: action.payload.res }
    case "CHANGE_MOVING_2":
      return { ...state, imChecked2: action.payload.res }
    case "CLEAN_STATE_FOR_MOVING_PARTS":
      return { ...state, imChecked: action.payload.objeto, partsChecked: [] }
    case "LEAN_STATE_FOR_MOVING_CHAPTERS":
      return {
        ...state,
        imChecked2: action.payload.objeto,
        chaptersChecked: [],
      }
    case "POST_GROUP_PARTS":
      state.budgetTree.postGroupParts(
        action.payload.chapter,
        action.payload.parts,
        action.payload.oldParts,
      )
      return {
        ...state,
        loadingAgruparParts: false,
      }
    case "POST_GROUP_CHAPTERS":
      state.budgetTree.postGroupChapters(
        action.payload.chapterCreated,
        action.payload.newChapters,
        action.payload.oldChapters,
      )
      return {
        ...state,
        loadingAgruparChapters: false,
      }
    case "UPDATE_TAGS_LIST":
      return {
        ...state,
        tags: action.payload.tagsList,
      }
    case "SAVE_TAGS_LIST":
      return {
        ...state,
        tagsFiltered: action.payload.tagsList,
      }
    case "CHANGE_VERSION":
      return {
        ...state,
        versionToDisplay: action.payload.version,
      }
    case "LOADING_BUDGET_PDF":
      return {
        ...state,
        loadingBudgetPDF: true,
      }
    case "SET_BUDGET_PDF":
      return {
        ...state,
        loadingBudgetPDF: false,
        budgetPDF: action.payload,
      }
    case "GROUPING_PARTS":
      return {
        ...state,
        loadingAgruparParts: true,
      }
    case "GROUPING_CHAPTERS":
      return {
        ...state,
        loadingAgruparChapters: true,
      }
    case CHANGE_SEND_BUDGET:
      return {
        ...state,
        sendChapters: action.payload,
      }
    case SENDING_MESSAGE:
      return {
        ...state,
        loadingSend: true,
        sendOk: false,
      }
    case SEND_COMPLETE:
      return {
        ...state,
        loadingSend: false,
        sendOk: true,
      }
    case RESET_SEND:
      return {
        ...state,
        loadingSend: false,
        sendOk: false,
      }
    case "COPY_DATA":
      return {
        ...state,
        copiedData: action.payload,
      }
    case "ADD_LAST_ACTION":
      console.log("aaaaa", action.payload)
      return {
        ...state,
        lastActions: [...state.lastActions, action.payload],
      }
    case "REMOVE_LAST_UNDO_ACTION":
      let newLastActions = state.lastActions.splice(-1)
      return {
        ...state,
        lastActions: newLastActions,
      }

    case IS_CONTRADICTING_PART:
      return {
        ...state,
        isContradictingPart: action.payload,
      }
    case IS_BUDGET_CLOSED:
      return {
        ...state,
        isBudgetClosed: action.payload,
        updating: false,
      }
    case SET_MODAL_BUDGETING_ERROR:
      return {
        ...state,
        modalBudgetingError: action.payload,
      }
    case DEL_CAPITULO_SET_POSITION:
      state.budgetTree.removeAndSetPosition(action.payload.capituloId)
      if (
        action.payload.totalDiscount != undefined ||
        action.payload.totalDiscount != null
      ) {
        state.budgetTree.updateDiscount(action.payload.totalDiscount, "root")
      }
      return {
        ...state,
        updating: false,
      }
    case REMOVE_ALL_PARTS_FROM_CHAPTER:
      state.budgetTree.removeAllPartsByChapterId(action.payload.chapterId)
      return {
        ...state,
        updating: false,
      }

    case MOVE_PARTS_BY_CHAPTERS_ID: {
      state.budgetTree.movePartsByChapterIds(
        action.payload.parentId,
        action.payload.chapterId,
      )
      return {
        ...state,
        updating: false,
      }
    }
    case SET_LOADING_ICON: {
      return {
        ...state,
        loadingIcon: action.payload,
      }
    }

    case SET_DYNAMIC_ELEMENT_MODAL_IS_OPEN: {
      return {
        ...state,
        dynamicElement: {
          ...state.dynamicElement,
          modalIsOpen: action.payload,
        },
      }
    }

    case SET_DYNAMIC_ELEMENT_SELECTED: {
      return {
        ...state,
        dynamicElement: {
          ...state.dynamicElement,
          selected: action.payload,
        },
      }
    }

    case SET_DYNAMIC_ELEMENT_PROJECT_ID: {
      return {
        ...state,
        dynamicElement: {
          ...state.dynamicElement,
          projectId: action.payload,
        },
      }
    }

    case SET_GENERAL_UPDATE: {
      return {
        ...state,
        certification: {
          ...state.certification,
          generalUpdate: action.payload,
        },
      }
    }

    case CERTIFICATION_LOADING: {
      return {
        ...state,
        certification: {
          ...state.certification,
          loading: action.payload,
        },
      }
    }

    case SET_CHAPTER_CERT_IN_PROGRESS: {
      return {
        ...state,
        certification: {
          ...state.certification,
          chapterCertInProgress: action.payload,
        },
      }
    }

    case CERT_DRAFT_SET_PARTIDA: {
      const { partidaId, included, draftMode = "total" } = action.payload
      const next = { ...(state.certDraftPartidaIds || {}) }
      if (included) {
        next[partidaId] = draftMode
      } else {
        delete next[partidaId]
      }
      return {
        ...state,
        certDraftPartidaIds: next,
      }
    }

    case SET_MARGIN_MODAL: {
      return {
        ...state,
        marginModal: {
          ...state.marginModal,
          open: action.payload.open,
          projectId: action.payload.projectId,
        },
      }
    }

    case SET_MARGIN_MODAL_INITIAL_VALUE: {
      const margin = action.payload.margin
      return {
        ...state,
        marginModal: {
          ...state.marginModal,
          generalExpenses: margin.generalExpenses,
          indirectExpenses: margin.indirectExpenses,
          industrialProfit: margin.industrialProfit,
          discount: margin.discount,
          formula: margin.formula,
        },
      }
    }

    case "SET_BUDGET_MODE": {
      return {
        ...state,
        budgetMode: action.payload,
      }
    }

    case "SET_BASE_CERT": {
      return {
        ...state,
        baseCert: action.payload,
      }
    }

    default:
      return state
  }
}
export default Budget2023Reducer
